import './NavigationPanel.css';
import menuOne from './../../images/menu-1.svg';
import menuTwo from './../../images/menu-2.svg';
import menuThree from './../../images/menu-3.svg';
import menuFour from './../../images/menu-4.svg';
import menuFive from './../../images/menu-5.svg';

import menuOneActive from './../../images/menu-1.svg';
import menuTwoActive from './../../images/menu-mp-active.svg';
import menuThreeActive from './../../images/menu-map-active.svg';
import menuFourActive from './../../images/menu-chat-active.svg';
import menuFiveActive from './../../images/menu-user-active.svg';

const NavigationPanel = ({ setCurrentPage, currentPage }) => {
    const handleMapClick = () => {
        setCurrentPage('MapPage');
    };

    const handleUserClick = () => {
        setCurrentPage('UserPage');
    };

    const handleMePointClick = () => {
        setCurrentPage('MePointPage');
    };

    const handleChatClick = () => {
        setCurrentPage('ChatPage');
    };

    const handleNavButtonClick = (page) => {
        setCurrentPage(page);
    };

    return (
        <div className='navigation__panel'>
            <div className='navigation__container'>
                <div className='navigation__items'>
                    <div className='navigation__item'>
                        <img src={menuOne} />
                    </div>

                    <div
                        className={`navigation__item ${
                            currentPage === 'MePointPage' ? 'active' : ''
                        }`}
                        onClick={handleMePointClick}
                    >
                        <img
                            src={
                                currentPage === 'MePointPage'
                                    ? menuTwoActive
                                    : menuTwo
                            }
                        />
                    </div>

                    <div
                        className={`navigation__item ${
                            currentPage === 'MapPage' ||
                            currentPage === 'EventJoinPage' ||
                            currentPage === 'AddEventPage' ||
                            currentPage === 'TypeEventsPage'
                                ? 'active'
                                : ''
                        }`}
                        onClick={handleMapClick}
                    >
                        <img
                            src={
                                currentPage === 'MapPage' ||
                                currentPage === 'EventJoinPage' ||
                                currentPage === 'AddEventPage' ||
                                currentPage === 'TypeEventsPage'
                                    ? menuThreeActive
                                    : menuThree
                            }
                        />
                    </div>

                    <div
                        className={`navigation__item ${
                            currentPage === 'ChatPage' ? 'active' : ''
                        }`}
                        onClick={handleChatClick}
                    >
                        <img
                            src={
                                currentPage === 'ChatPage'
                                    ? menuFourActive
                                    : menuFour
                            }
                        />
                    </div>

                    <div
                        className={`navigation__item ${
                            currentPage === 'UserPage' ? 'active' : ''
                        }`}
                        onClick={handleUserClick}
                    >
                        <img
                            src={
                                currentPage === 'UserPage'
                                    ? menuFiveActive
                                    : menuFive
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NavigationPanel;
